import React from "react";
import { BadgeCheck, Video } from "lucide-react";

export const PASSPORT_PEOPLE = [
    { name: "Marcus Reid", role: "HR Manager", match: 96, trust: 92, img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=120" },
    { name: "Daniel Ortiz", role: "Operations Lead", match: 93, trust: 89, img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=120" },
    { name: "Claire Bennett", role: "People Partner", match: 91, trust: 95, img: "https://images.unsplash.com/photo-1699899657680-421c2c2d5064?crop=entropy&cs=srgb&fm=jpg&q=85&w=120" },
    { name: "Amara Diallo", role: "HRBP, Bilingual", match: 89, trust: 94, img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=120" },
    { name: "Sofia Ramirez", role: "Talent Coordinator", match: 87, trust: 90, initials: "SR" },
];

export const PassportCard = ({ person, compact = false }) => (
    <div
        data-testid={`passport-card-${person.name.toLowerCase().replace(/\s+/g, "-")}`}
        className={`rounded-xl border border-border bg-card shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 ${compact ? "p-3" : "p-4"}`}
    >
        <div className="flex items-center gap-3">
            {person.img ? (
                <img src={person.img} alt={person.name} className={`${compact ? "w-9 h-9" : "w-11 h-11"} rounded-full object-cover`} />
            ) : (
                <div className={`${compact ? "w-9 h-9 text-xs" : "w-11 h-11 text-sm"} rounded-full bg-brand-navy text-white flex items-center justify-center font-semibold dark:bg-slate-700`}>
                    {person.initials}
                </div>
            )}
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                    <span className={`font-heading font-semibold text-foreground truncate ${compact ? "text-xs" : "text-sm"}`}>{person.name}</span>
                    <BadgeCheck size={compact ? 13 : 15} className="text-emerald-500 shrink-0" />
                </div>
                <div className={`text-muted-foreground truncate ${compact ? "text-[10px]" : "text-xs"}`}>{person.role}</div>
            </div>
            <div className="text-right shrink-0">
                <div className={`mono-score font-bold text-emerald-600 dark:text-emerald-400 ${compact ? "text-sm" : "text-base"}`}>{person.match}%</div>
                <div className="text-[9px] uppercase tracking-wider text-muted-foreground">Match</div>
            </div>
        </div>
        {!compact && (
            <div className="mt-3 flex items-center justify-between text-[10px]">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent px-2 py-0.5 font-medium text-accent-foreground">
                    <span className="mono-score">Trust {person.trust}</span>
                </span>
                <span className="inline-flex items-center gap-1 text-muted-foreground">
                    <Video size={11} /> Video intro
                </span>
            </div>
        )}
    </div>
);

export default PassportCard;
